import BaseAPI from '@/apis/base/baseApi';
import commonFn from '@/commons/commonFunction';
class AvatarAPI extends BaseAPI {
    constructor() {
        super();
    }
    apiName = 'Avatar';

    getAPIUrl() {
        return `${window._misaId?.baseUrl}`;
    }
    /**
     * lấy link gọi file
     * trả về content-type theo type - không force downoad
     * @param {*} type : File gì
     * @param {*} name : tên file server
     * @param {*} width : độ rộng ảnh
     * @param {*} height : chiều dài ảnh
     * @param {*} quantity : độ phân giải
     */
    getAvatarLink(id, size = 64) {
        return `${this.getAPIUrl()}/image/getavatar?userId=${id}&width=${size}&height=${size}`;
    }
}

export default new AvatarAPI();
